/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface ColorMode {
}

export enum ColorMode_Enum {
  COLOR_DEFAULT = 0,
  COLOR_VIBRANT = 1,
  COLOR_FLAT = 2,
  COLOR_HLG = 3,
  COLOR_HDR10 = 4,
  UNRECOGNIZED = -1,
}

export function colorMode_EnumFromJSON(object: any): ColorMode_Enum {
  switch (object) {
    case 0:
    case "COLOR_DEFAULT":
      return ColorMode_Enum.COLOR_DEFAULT;
    case 1:
    case "COLOR_VIBRANT":
      return ColorMode_Enum.COLOR_VIBRANT;
    case 2:
    case "COLOR_FLAT":
      return ColorMode_Enum.COLOR_FLAT;
    case 3:
    case "COLOR_HLG":
      return ColorMode_Enum.COLOR_HLG;
    case 4:
    case "COLOR_HDR10":
      return ColorMode_Enum.COLOR_HDR10;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ColorMode_Enum.UNRECOGNIZED;
  }
}

export function colorMode_EnumToJSON(object: ColorMode_Enum): string {
  switch (object) {
    case ColorMode_Enum.COLOR_DEFAULT:
      return "COLOR_DEFAULT";
    case ColorMode_Enum.COLOR_VIBRANT:
      return "COLOR_VIBRANT";
    case ColorMode_Enum.COLOR_FLAT:
      return "COLOR_FLAT";
    case ColorMode_Enum.COLOR_HLG:
      return "COLOR_HLG";
    case ColorMode_Enum.COLOR_HDR10:
      return "COLOR_HDR10";
    case ColorMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseColorMode(): ColorMode {
  return {};
}

export const ColorMode = {
  encode(_: ColorMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ColorMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseColorMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ColorMode {
    return {};
  },

  toJSON(_: ColorMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ColorMode>, I>>(base?: I): ColorMode {
    return ColorMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ColorMode>, I>>(_: I): ColorMode {
    const message = createBaseColorMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
